import { headerAndFooter as config } from '@config';

const createElement = (canvas, name) => (target, attributes) => {
  return canvas.addSvgElementFromJson({
    element: name,
    curStyles: false,
    attr: attributes
  }, target);
};

export function createLayout (canvas) {
  const createGroup = createElement(canvas, 'g');
  const createRect = createElement(canvas, 'rect');

  return (layer, { size }) => {
    return ['header', 'footer']
      .forEach(name => {
        const group = createGroup(layer, {
          id: config[name].id,
          class: 'non-selectable'
        });

        createRect(group, {
          ...size[name],
          id: config[name].rectId,
          fill: 'none',
          'stroke-width': 0
        });

        return group;
      });
  };
}
